import { FileDownload } from '@mui/icons-material';
import { Dialog } from '@mui/material';
import { FC } from 'react';
import Button from 'components/Button';
import { useLanguage } from 'context/AppContext';
import * as Styles from './DataUploadTemplatesDialog.styles';

interface DataUploadTemplatesDialogParams {
  open: boolean;
  onClose: () => void;
}

const DataUploadTemplatesDialog: FC<DataUploadTemplatesDialogParams> = ({ open, onClose }) => {
  const [language] = useLanguage();

  return (
    <Dialog open={open} onClose={onClose}>
      <Styles.Title>{language.DataUpload.template.title}</Styles.Title>
      <Styles.Content>
        <Styles.ContentText>{language.DataUpload.template.bodyText1}</Styles.ContentText>
        <Styles.ContentText>{language.DataUpload.template.bodyText2}</Styles.ContentText>
        <Styles.ContentItem>
          <Styles.ContentHeading variant="subtitle1">
            {language.DataUpload.template.deviceTemplatesTitle}
          </Styles.ContentHeading>
          <Styles.DownloadableItem href="/DEVICE_UPLOAD_DATA_TEMPLATE.csv" download>
            <FileDownload />
            {language.DataUpload.template.deviceTemplatesFileName}
          </Styles.DownloadableItem>
        </Styles.ContentItem>
        <Styles.ContentItem>
          <Styles.ContentHeading variant="subtitle1">
            {language.DataUpload.template.bomTemplatesTitle}
          </Styles.ContentHeading>
          <Styles.DownloadableItem href="/BOM_UPLOAD_DATA_TEMPLATE.csv" download>
            <FileDownload />
            {language.DataUpload.template.bomTemplatesFileName}
          </Styles.DownloadableItem>
        </Styles.ContentItem>
        <Styles.ContentItem>
          <Styles.ContentHeading variant="subtitle1">
            {language.DataUpload.template.bomSerialNumberTemplatesTitle}
          </Styles.ContentHeading>
          <Styles.DownloadableItem href="/SET_SERIAL_NUMBER_UPLOAD_TEMPLATE.csv" download>
            <FileDownload />
            {language.DataUpload.template.bomSerialNumberTemplatesFileName}
          </Styles.DownloadableItem>
        </Styles.ContentItem>
        <Styles.ContentItem>
          <Button onClick={() => onClose()}>{language.DataUpload.template.close}</Button>
        </Styles.ContentItem>
      </Styles.Content>
    </Dialog>
  );
};

export default DataUploadTemplatesDialog;
